import { FC, useState } from 'react';
import { useRouter } from 'next/router';
import EfSwiperLevel2 from '@elem/ui/ef-swiper-level2';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

const TheComp: FC = () => {
    const { t } = useLang('dp3.landing.Member');
    const { locale } = useRouter();
    const [listA, setListA] = useState([
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719036838999/c1%20(1).jpg',
            h5List: [
                'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718764767896/h51.jpg',
                'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719037258822/d1%20(1).jpg',
            ],
            upTitle: t('item1_t'),
            subtitle: t('item1_l'),
            desc: t('item1_r'),
        },
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718886551642/a3%20(1).jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718769266107/a1.jpg',
            upTitle: t('item2_t'),
            subtitle: t('item2_l'),
            desc: t('item2_r'),
        },
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718708607081/a3%20(1).jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718769441450/b1%20(1).jpg',
            upTitle: t('item3_t'),
            subtitle: t('item3_l'),
            desc: t('item3_r'),
        },
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718886829823/b1%20(1).jpg',
            h5List: [
                'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718768869115/c1.jpg',
                'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718799387979/a1.jpg',
            ],
            upTitle: t('item4_t'),
            subtitle: t('item4_l'),
            desc: t('item4_r'),
        },
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719055675644/bb2.jpeg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719037036923/c3%20(1).jpg',
            upTitle: t('item5_t'),
            subtitle: t('item5_l'),
            desc: t('item5_r'),
        },
    ]);
    return (
        <div
            id="dp3-teaser-E11"
            className={`Smoothly dp3-teaser-E ${styles.theComp} GtmModuleData-section`}
            data-section-id={'dp3-MemberB'}
            data-section-title={t('title')}
        >
            <div className="comp-module dp3-module-box">
                <div className="dp3-title">{t('title')}</div>
                {/* <SwiperCommon list={listA} /> */}
            </div>
            <EfSwiperLevel2 list={listA} hasLevel2={true} />
        </div>
    );
};

export default TheComp;
